import { getRequest, postRequest } from '../../utils'
import { authServiceUrl } from '../../urls'

export const getHostListReq = (page = 0, size = 100) => {
  return getRequest(`${authServiceUrl}/admin/hosts` + (`?page=${page}`) + (`&size=${size}`))
}

export const getBlockedHostListReq = () => {
  return getRequest(`${authServiceUrl}/admin/hosts/blocked`)
}

export const blockHostReq = (phone: string, reason: string) => {
  return postRequest(`${authServiceUrl}/admin/hosts/block`, { phone, reason })
}
